import { CustomSearchCriteria } from '@catalog/const';
import { StateUtils } from '@spartacus/core';
import { FACETS_TOTAL_RESULTS } from '../search-state';

export const LOAD_SEARCH_FACETS_TOTAL_RESULTS = '[Search] Search Facets Total Results Load';
export const LOAD_SEARCH_FACETS_TOTAL_RESULTS_SUCCESS = '[Search] Search Facets Total Results Load Success';
export const LOAD_SEARCH_FACETS_TOTAL_RESULTS_FAIL = '[Search] Search Facets Total Results Load Fail';
export class SearchFacetsTotalResultsLoad extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_SEARCH_FACETS_TOTAL_RESULTS;

  constructor(public payload: CustomSearchCriteria) {
    super(FACETS_TOTAL_RESULTS);
  }
}

export class SearchFacetsTotalResultsLoadFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_SEARCH_FACETS_TOTAL_RESULTS_FAIL;

  constructor(public payload: any) {
    super(FACETS_TOTAL_RESULTS, payload);
  }
}

export class SearchFacetsTotalResultsLoadSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_SEARCH_FACETS_TOTAL_RESULTS_SUCCESS;

  constructor(public payload: number) {
    super(FACETS_TOTAL_RESULTS);
  }
}

export type SearchFacetsAction =
  | SearchFacetsTotalResultsLoad
  | SearchFacetsTotalResultsLoadSuccess
  | SearchFacetsTotalResultsLoadFail;
